var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "theme-ui/jsx-runtime";
import React from "react";
import { Box, Flex } from "theme-ui";
import { BreadCrumbDivider } from "./BreadCrumbDivider";
export const BreadCrumbs = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (_jsx(Flex, Object.assign({ sx: {
            borderBottom: "1px solid",
            borderColor: "grey.3"
        } }, props, { children: _jsx(Box, { as: "nav", "aria-label": "breadcrumb", sx: {
                py: 24
            }, children: _jsx(Box, { as: "ol", sx: {
                    listStyleType: "none",
                    whiteSpace: "nowrap",
                    display: "inline-flex",
                    boxSizing: "border-box",
                    overflow: "visible",
                    margin: 0,
                    pr: 24
                }, children: children &&
                    children.map((item, idx) => (_jsxs(React.Fragment, { children: [item, item && idx < children.length - 1 && _jsx(BreadCrumbDivider, {})] }, idx))) }) }) })));
};
//# sourceMappingURL=BreadCrumbs.js.map